<div
  class="table-header d-flex flex-wrap align-items-center s-p-4 border rounded-top border-bottom-0"
>
  <div class="col d-flex gap-1">
    <ng-content select="[slot=filter]"> </ng-content>
  </div>
  <div
    class="flex-grow-3 d-flex flex-column align-items-center justify-content-center registers-count"
  >
    <p class="text-uppercase s-bold">
      {{ title() ? title() : ("registers-total" | transloco) }}
    </p>
    <span class="s-heading-3">{{ total() }}</span>
  </div>
  <div class="col d-flex justify-content-end gap-1">
    <ng-content select="[slot=actions]"> </ng-content>
  </div>
</div>
